angular
    .module('app')
    .component('winbackStateOffers', {
        templateUrl: '/templates/pages/winback-state-offers/winback-state-offers.html',
        controller: 'WinbackStateOffersController',
        controllerAs: 'vm',
    });